import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import classNames from 'classnames';
import { FLINT, GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
import UICloseButton from '../button/UICloseButton';
import { allSizes } from '../utils/propTypes/tshirtSize';
import { setBorderRadius, setDistance } from '../utils/Styles';
import { TileContextProvider, defaultTileContext } from '../context/TileContext';
const compactTileContext = {
  compact: true
};
const spacedMixin = css([".private-tile + &{margin-top:16px;}"]);
const Tile = styled.div.withConfig({
  displayName: "UITile__Tile",
  componentId: "sc-1scj01o-0"
})(["position:relative;", ";background-color:", ";border:1px solid ", ";", ";", ""], setBorderRadius(), OLAF, GREAT_WHITE, ({
  distance
}) => distance && setDistance(distance), ({
  distance
}) => !distance && spacedMixin);
const CloseButton = styled(UICloseButton).withConfig({
  displayName: "UITile__CloseButton",
  componentId: "sc-1scj01o-1"
})(["right:12px;top:12px;"]);
export default function UITile(_ref) {
  let {
    children,
    className,
    closeable,
    compact,
    onClose
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "className", "closeable", "compact", "onClose"]);

  return /*#__PURE__*/_jsx(TileContextProvider, {
    value: compact ? compactTileContext : defaultTileContext,
    children: /*#__PURE__*/_jsxs(Tile, Object.assign({}, rest, {
      className: classNames('private-tile', className),
      children: [closeable ? /*#__PURE__*/_jsx(CloseButton, {
        color: FLINT,
        onClick: onClose,
        size: "sm"
      }) : null, children]
    }))
  });
}
UITile.displayName = 'UITile';
UITile.propTypes = {
  children: PropTypes.node.isRequired,
  closeable: PropTypes.bool.isRequired,
  compact: PropTypes.bool.isRequired,
  distance: PropTypes.oneOfType([allSizes, PropTypes.oneOf(['flush'])]),
  onClose: PropTypes.func
};
UITile.defaultProps = {
  closeable: false,
  compact: false
};